import Phaser from "phaser";
import WebFontFile from "./FontLoader";

export default class TitleScreen extends Phaser.Scene {

  preload() {

    const fonts = new WebFontFile(this.load, "Press Start 2P");
    this.load.addFile(fonts);

  }

  create() {

    // 1. get current width and height
    const width = this.scale.width;
    const height = this.scale.height;

    // 2. pass the width and height and devide by 2 to get the half of the screen
    const title = this.add.text(width / 2, height / 2, 'Catch the Ball', {
      fontSize: 40,
      color: '#cdd6f4',
      fontFamily: "'Press Start 2P'"
    })
    title.setOrigin(0.5);

    const pressSpace = this.add.text(width / 1.5, height / 1.8, 'Press SPACE To Start!', {
      fontFamily: "'Press Start 2P'",
      fontSize: 13,
      color: '#cdd6f4'
    })

    this.input.keyboard.once('keydown-SPACE', () => {
      this.scene.start('game');
    })
  }
}
